/**
 * Shows the regular product page until the configurator iframe reports ready.
 * Ready is IFRAME_RESIZE / IFRAME_LOCK_SCROLL from postMessageParent.js.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.configuratorLoaderReady === 'true') return;
    root.dataset.configuratorLoaderReady = 'true';

    const embed = root.querySelector('[data-configurator-embed]');
    const fallback = root.querySelector('[data-configurator-fallback]');
    const status = root.querySelector('[data-configurator-status]');
    const frame = embed && embed.querySelector('iframe');
    if (!embed || !fallback || !frame) return;

    let revealed = false;

    function reveal() {
      if (revealed) return;
      revealed = true;
      embed.classList.remove('is-loading');
      fallback.hidden = true;
      fallback.setAttribute('inert', '');
      if (status) status.hidden = true;
      root.classList.add('is-configurator-ready');
      const section = root.closest('.shopify-section');
      if (section) {
        section.classList.add('is-configurator-ready');
        syncProductTabs(section);
      }
    }

    function syncProductTabs(fromSection) {
      let sibling = fromSection.nextElementSibling;
      let tabsRoot = null;

      while (sibling) {
        tabsRoot = sibling.querySelector('.product-tabs-wrapper');
        if (tabsRoot) break;
        sibling = sibling.nextElementSibling;
      }

      if (!tabsRoot) return;

      ['tab-desc', 'tab-info'].forEach(function (id) {
        tabsRoot.querySelectorAll('[data-tab="' + id + '"], #' + id).forEach(function (el) {
          el.hidden = true;
          el.classList.remove('active');
        });
      });

      const docLink = tabsRoot.querySelector('[data-tab="tab-doc"]');
      const docPanel = tabsRoot.querySelector('#tab-doc');

      if (docLink && docPanel) {
        docLink.hidden = false;
        docLink.classList.add('active');
        docPanel.hidden = false;
        docPanel.classList.add('active');
        return;
      }

      sibling.hidden = true;
      sibling.setAttribute('inert', '');
    }

    function onMessage(event) {
      if (frame.contentWindow !== event.source || !event.data) return;
      if (event.data.type === 'IFRAME_RESIZE' || event.data.type === 'IFRAME_LOCK_SCROLL') {
        reveal();
      }
    }

    window.addEventListener('message', onMessage);

    window.setTimeout(function () {
      if (!revealed && status) status.hidden = true;
    }, 20000);
  }

  document.querySelectorAll('[data-configurator-page]').forEach(init);
})();
